<script lang="ts" setup>
import KUIUnifiedBackButton from '~kui/components/KUI/Unified/UnifiedBackButton.vue';

import UnifiedLearnBadgeIA from '~/components/Unified/IA/UnifiedLearnBadgeIA.vue';
import { IaPageAudience } from '~/composables/unified/useIaAudience';
import { useIaPlaces } from '~/composables/unified/useIaPlaces';

definePageMeta({
  authType: [AUTH_ROUTE_TYPE_NONE],
  name: 'unified-learn-badge',
  layout: 'unified-public',
  // The page sets its own width, so it lines up with the bar.
  unifiedPublic: { fullWidth: true },
  unavailableOnSchools: { navigateToLink: '/coach/badges' },
  // A signed-in student has the badge in the coach shell.
  ia: { audience: IaPageAudience.All, off: '/learn', on: '/coach/badges/:slug' },
});

/** A badge's public page, which guests can read before signing up to earn it. */
const route = useRoute();
const slug = String(route.params.slug);
const places = useIaPlaces();

useSeoMeta({
  robots: 'noindex, nofollow',
});

const back = () => navigateTo(places.learnCategory('badges'));
</script>

<template>
  <div class="relative flex min-h-screen flex-col" data-testid="learn-ia-badge-page">
    <KUIUnifiedBackButton @back="back" />
    <UnifiedLearnBadgeIA :slug="slug" />
  </div>
</template>
